export default "__VITE_ASSET__Dm3q9yW___"